import React from "react";
import styles from "../../pages/Monitor/Monitor.module.css";
import SensorControlCard from "./SensorControlCard";

const isVisibleByUser = (visibilityMap, index) => {
  if (!visibilityMap) return true;

  const value = visibilityMap[index] ?? visibilityMap[String(index)];

  if (value === undefined || value === null) {
    return true;
  }

  return (
    value === true ||
    value === 1 ||
    value === "1" ||
    value === "true" ||
    value === "TRUE"
  );
};

const SensorGrid = ({
  type,
  count,
  label,
  icon,
  unit,
  sensorData = {},
  suspendedSensors = new Set(),
  onUpdate,
  CardComponent = SensorControlCard,
  customNames = {},
  allCustomNames = {},
  onSaveCustomName,
  onOpenArchiveTable,
  onOpenSettings,
  onlyIndex = null,

  serial,
  token,

  // قابلیت نمایش / عدم نمایش در مانیتورینگ
  visibilitySettings = {},
  filterByVisibility = false,
  showVisibilityToggle = false,
  onSaveVisibility,

  canConfigure = true,
  canControlOutputs = true,
  readOnlyPreview = false,
}) => {
  const items = [];

  const canUpdate = typeof onUpdate === "function";

  const handleCardUpdate = (inputType, inputIndex, prop, value) => {
    if (!canUpdate) return undefined;

    return onUpdate(inputType, inputIndex, prop, value);
  };

  const handleOpenArchiveTable = (inputType, inputIndex, fallbackTitle) => {
    if (typeof onOpenArchiveTable !== "function") return undefined;

    const sensorKey = `${inputType}${inputIndex}`;

    return onOpenArchiveTable({
      type: inputType,
      index: inputIndex,
      sensorKey,
      title: fallbackTitle || sensorKey,
      unit: unit || "",
    });
  };

  for (let i = 0; i < count; i++) {
    if (onlyIndex !== null && Number(onlyIndex) !== i) {
      continue;
    }

    const key = `${type}${i}`;
    const data = sensorData[key];

    const isVisibleInMonitor = isVisibleByUser(visibilitySettings, i);

    // اگر این Grid برای صفحه مانیتورینگ اصلی است،
    // آیتم‌هایی که کاربر مخفی کرده نمایش داده نمی‌شوند.
    // اما در تنظیمات filterByVisibility=false است، پس همچنان دیده می‌شوند.
    if (filterByVisibility && !isVisibleInMonitor) {
      continue;
    }

    const isOfflinePreviewItem = Boolean(
      data?.isOfflinePreview ||
      data?.isLastStatePreview ||
      data?.readOnlyPreview ||
      readOnlyPreview,
    );

    if (
      data &&
      !suspendedSensors.has(key) &&
      (data.connected || isOfflinePreviewItem)
    ) {
      const customName = customNames?.[i] ?? customNames?.[String(i)];
      const displayTitle =
        customName !== undefined &&
        customName !== null &&
        String(customName).trim() !== ""
          ? String(customName).trim()
          : `${label} ${i}`;

      items.push(
        <CardComponent
          key={key}
          type={type}
          index={i}
          label={`${label} ${i}`}
          icon={icon}
          unit={unit}
          data={data}
          onUpdate={
            canUpdate
              ? (prop, value) => handleCardUpdate(type, i, prop, value)
              : undefined
          }
          customNames={customNames}
          allCustomNames={allCustomNames}
          allSensorData={sensorData}
          onSaveCustomName={onSaveCustomName}
          onOpenArchiveTable={
            typeof onOpenArchiveTable === "function"
              ? (payload = {}) =>
                  handleOpenArchiveTable(
                    payload.type || type,
                    payload.index ?? i,
                    payload.title || displayTitle,
                  )
              : undefined
          }
          onOpenSettings={
            canConfigure &&
            !isOfflinePreviewItem &&
            typeof onOpenSettings === "function"
              ? () => onOpenSettings(type, i)
              : undefined
          }
          serial={serial}
          token={token}
          showVisibilityToggle={showVisibilityToggle}
          isVisibleInMonitor={isVisibleInMonitor}
          onVisibilityChange={(nextValue) => {
            if (onSaveVisibility) {
              return onSaveVisibility(type, i, nextValue);
            }

            return undefined;
          }}
          canConfigure={canConfigure}
          canControlOutputs={canControlOutputs}
          readOnlyPreview={isOfflinePreviewItem}
        />,
      );
    }
  }

  if (items.length === 0) {
    return (
      <div className={styles.emptySection}>
        موردی برای نمایش در این بخش یافت نشد.
      </div>
    );
  }

  return <div className={styles.sensorsGrid}>{items}</div>;
};

export default SensorGrid;
